export default __webpack_public_path__ + "4fd353c02f6eb26b855de5f6b2d3358f.png";